import moment from "moment/moment";
import { putInvoiceOffline, putLogToFirebase } from "../../store/offlineDb";
import { getSessionSelectedLocation } from "../session";
import { customAxios } from "../../api/axios";
import { doc, setDoc } from "firebase/firestore";
import { AUTH, DB } from "../../auth/FirebaseContext";
import { loginOnError403 } from "../../api/vpfr";
import { postInvoiceLpfr } from "../../api/lpfr";

export async function insertNewInvoice(data) {
  return new Promise(async (resolve, reject) => {
    await insertInvoice(data).then(async ({ invoice, source }) => {
      if (source === "lpfr") {
        await insertIntoFirestore(data, invoice);
      }
      return resolve(invoice);
    }).catch(reason => {
      return reject(reason);
    });
  });
}

export function insertInvoice(data, isAlreadyPosted = false) {
  return new Promise(async (resolve, reject) => {
    await postInvoiceVpfr(data).then(response => {
      resolve({ invoice: response.data, source: "vpfr" });
    }).catch(async e => {
      parseInsertInvoiceError(e, reject);
      if (!isAlreadyPosted) {
        await loginOnError403(e).then(_ => {
          insertInvoice(data, true).then(r => {
            resolve(r);
          });
        });
      } else {
        await postInvoiceLpfr(data).then(response => {
          resolve({ invoice: response.data, source: "lpfr" });
        }).catch(reason => {
          reject(reason);
        });
      }
    });
  });
}

export function postInvoiceVpfr(data) {
  const token = AUTH.currentUser.stsTokenManager.accessToken;
  const pac = getSessionSelectedLocation().PAC;
  return customAxios(token, pac).post("/api/v3/invoices", data);
}


export async function insertIntoFirestore(data, response) {
  const timestamp = getTimestampFromSdc(response.sdcDateTime);
  if (typeof data === "string") {
    data = JSON.parse(data);
  }

  try {
    const invoiceType = convertInvoiceType(data.invoiceType);
    const transactionType = convertTransactionType(data.transactionType);
    const paymentMethod = convertPaymentMethod(data.payment);
    const itemsFromData = getItemsFromData(data.items);

    let obj = {
      totalCounter: response.totalCounter,
      dateAndTimeOfIssue: data.dateAndTimeOfIssue || null,
      buyerCostCenter: data.buyerCostCenter || null,
      buyerTin: data.buyerId || null,
      cashier: data.cashier,
      invoiceNumber: response.invoiceNumber,
      invoiceType: invoiceType,
      items: itemsFromData,
      paymentMethod: paymentMethod,
      referentDocumentDT: data.referentDocumentDT || null,
      referentDocumentNumber: data.referentDocumentNumber || null,
      sdcDateTime: response.sdcDateTime,
      taxItems: response.taxItems,
      totalAmount: response.totalAmount,
      transactionType: transactionType,
      internalData: {
        ...data.internalData,
        client: "webBus"
      }
    };
    await   putInvoiceOffline({
      ...obj,
      isInsertedOffline: true,
      invoiceType: data.invoiceType,
      paymentMethod: data.payment,
      transactionType: data.transactionType
    });
    //INVOICE
    const colRef = doc(DB, "invoices", "users", `${AUTH.currentUser.uid}`, timestamp);
    await setDoc(colRef, obj, { merge: true }).then(_ => {
      console.debug("Uspesno sacuvan racun na firestoru");
    }).catch(reason => {
      console.error("reason", reason);
      putLogToFirebase("insertIntoFirestore", "vpfr.js", [data, response], reason?.toString());
    });
  } catch (e) {
    console.error("e", e);
    putLogToFirebase("insertIntoFirestore", "vpfr.js", [data, response], e?.toString());
  }
}

export function getTimestampFromSdc(sdcDateTime) {
  try {
    return moment(sdcDateTime).format("x");
  } catch (e) {
    return new Date().toString();
  }
}

function parseInsertInvoiceError(e, reject) {
  if (e?.response?.status === 400) {
    if (e?.response?.data) {
      reject(e.response.data);
    } else {
      reject(e);
    }
  }
}

export const convertInvoiceType = (data) => {
  switch (data) {
    case "Normal":
      return "0";
    case "Proforma":
      return "1";
    case "Copy":
      return "2";
    case "Training":
      return "3";
    case "Advance":
      return "4";
    default:
      return "-1";
  }
};
export const convertTransactionType = (data) => {
  switch (data) {
    case "Sale":
      return "0";
    case "Refund":
      return "1";
    default:
      return "-1";
  }
};
export const convertPaymentMethod = (data) => {
  return data.map(obj => {
    if (obj.paymentType === "Other") {
      return { ...obj, paymentType: "0" };
    } else if (obj.paymentType === "Cash") {
      return { ...obj, paymentType: "1" };
    } else if (obj.paymentType === "Card") {
      return { ...obj, paymentType: "2" };
    } else if (obj.paymentType === "Check") {
      return { ...obj, paymentType: "3" };
    } else if (obj.paymentType === "WireTransfer") {
      return { ...obj, paymentType: "4" };
    } else if (obj.paymentType === "Voucher") {
      return { ...obj, paymentType: "5" };
    } else if (obj.paymentType === "MobileMoney") {
      return { ...obj, paymentType: "6" };
    }
    return obj;
  });
};
const getItemsFromData = (data) => {
  let arr = [];
  for (let i = 0; i < data.length; i++) {
    let object ={};
    object.name = data[i].name || null;
    object.uid = data[i].uid || null;
    object.ean = data[i].ean || null;
    object.code = data[i].code || null;
    object.labels = data[i].labels || null;
    object.vat = data[i].vat || null;
    object.unit = data[i].unit || null;
    object.quantity = data[i].quantity || null;
    object.totalAmount = parseFloat(parseFloat(data[i].totalAmount).toFixed(2));
    object.unitPrice = parseFloat(parseFloat(data[i].unitPrice).toFixed(2));
    arr.push(object);
  }
  return arr;
};
